var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$userCan(_vm.permission))?_c('div',[_vm._t("default")],2):_c('div',[_vm._v("You are not allowed to view this page")])])}
var staticRenderFns = []

export { render, staticRenderFns }